import React, { Component } from "react";
import { FiMail, FiMapPin, FiPhone } from "react-icons/fi";

class ContactOne extends Component{
    constructor(props){
        super(props);
        this.state = {
            rnName: '',
            rnEmail: '',
            rnSubject: '',
            rnMessage: '',
        };
        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(e) {
        e.preventDefault();
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ subject: this.state.rnSubject, content: this.state.rnMessage, name: this.state.rnName, email: this.state.rnEmail, recipient: 'eventsessens@gmail.com', webSite: 'essens-events.fr' })
        };
        // console.log('state : ' + JSON.stringify(this.state));
        fetch('https://www.danceschool.fr/api/mail/contact', requestOptions)
            .then(response => response.status)
            .then(status => {
                this.setState({
                    rnName: '',
                    rnEmail: '',
                    rnSubject: '',
                    rnMessage: '',
                    sent: true
                });
            })
            .catch(console.error);
    }

    render(){
        return(
            <div className="contact-form--1" style={{color: 'white'}}>
                <div className="container">
                    <div className="row row--35 align-items-start  d-flex">
                        <div className="col-lg-6 order-2 order-lg-1">
                            <div className="section-title text-left mb--30">
                                <h2 className="title mt--30" style={{color: 'white', fontFamily: 'Alex Brush'}}>Contactez-nous</h2>
                                { this.state.sent &&
                                    <div className="alert alert-success alert-dismissible fade show" role="alert">
                                        Votre message a bien &eacute;t&eacute; envoy&eacute;.
                                    </div>
                                }
                                <div className="im_address_inner">
                                    <div className="im_address">
                                        <span>ESSENS</span>
                                    </div>
                                    <div className="im_address mt--5">
                                        <span>200 rue de la Croix Nivert - 75015 PARIS</span>
                                    </div>
                                    <div className="im_address mt--5">
                                        <span>Tél : 06.50.68.43.55</span>
                                    </div>
                                    <div className="im_address mt--5">
                                        <span>Numéro SIREN : 814046710</span>
                                    </div>

                                    <div className="d-flex im_address mt--10">
                                        <div className="my-icon mr-2" style={{fontSize: '22px', position: 'relative', top: '-8px'}}>
                                            <FiMail />
                                        </div>
                                        <span>eventsessens@gmail.com</span>
                                    </div>
                                </div>
                            </div>
                            <div className="form-wrapper">
                                <form onSubmit={this.onSubmit}>
                                    <label htmlFor="item01">
                                        <input
                                            type="text"
                                            name="name"
                                            id="item01"
                                            value={this.state.rnName}
                                            onChange={(e)=>{this.setState({rnName: e.target.value});}}
                                            placeholder="Votre nom *"
                                        />
                                    </label>

                                    <label htmlFor="item02">
                                        <input
                                            type="text"
                                            name="email"
                                            id="item02"
                                            value={this.state.rnEmail}
                                            onChange={(e)=>{this.setState({rnEmail: e.target.value});}}
                                            placeholder="Votre e-mail *"
                                        />
                                    </label>

                                    <label htmlFor="item03">
                                        <input
                                            type="text"
                                            name="subject"
                                            id="item03"
                                            value={this.state.rnSubject}
                                            onChange={(e)=>{this.setState({rnSubject: e.target.value});}}
                                            placeholder="Sujet"
                                        />
                                    </label>
                                    <label htmlFor="item04">
                                        <textarea
                                            type="text"
                                            id="item04"
                                            name="message"
                                            value={this.state.rnMessage}
                                            onChange={(e)=>{this.setState({rnMessage: e.target.value});}}
                                            placeholder="Message"
                                        />
                                    </label>
                                    <button className="btn-default" type="submit" value="submit" name="submit" id="mc-embedded-subscribe">Envoyer</button>
                                </form>
                            </div>
                        </div>
                        <div className="col-lg-6 order-1 order-lg-2" style={{alignSelf: 'center'}}>
                            <div className="thumbnail mb_md--30 mb_sm--30 ml--100">
                                {/*<img src="/assets/images/about/about-11.jpg" alt="trydo"/>*/}
                                <img src="/assets/images/logo/logo-essens300.png" style={{boxShadow: 'initial'}} alt="About Images"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default ContactOne;